<template>
    <YearPickerHeading
        v-slot="{ headingValue }"
        :class="cn('text-content-sm font-medium', props.class)"
        v-bind="forwardedProps"
    >
        <slot :heading-value>
            {{ headingValue }}
        </slot>
    </YearPickerHeading>
</template>

<script setup lang="ts">
import type { YearPickerHeadingProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { YearPickerHeading, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<YearPickerHeadingProps & { class?: HTMLAttributes['class'] }>();

defineSlots<{
    default: (props: { headingValue: string }) => unknown;
}>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
